import { cn } from "@/utils/cn";
import { Brandmark } from "@/components/primitives";
import { Icon } from "@/components/Icon/Icon";

type SidebarHeaderProps = {
  compact: boolean;
  onToggleCompact: () => void;
  onBackToStart: () => void;
};

export function SidebarHeader({
  compact,
  onToggleCompact,
  onBackToStart,
}: SidebarHeaderProps) {
  return (
    <div className={cn("sidebar-header", compact && "collapsed")}>
      <div
        className="hstack"
        style={{ justifyContent: compact ? "center" : "space-between", gap: 8 }}
      >
        {!compact && (
          <button
            type="button"
            onClick={onBackToStart}
            style={{
              cursor: "pointer",
              background: "transparent",
              border: "none",
              padding: 0,
            }}
          >
            <Brandmark />
          </button>
        )}
        <button
          type="button"
          onClick={onToggleCompact}
          title={compact ? "Expand sidebar" : "Collapse sidebar"}
          className="sidebar-collapse-btn"
        >
          <Icon name="panel-l" size={16} />
        </button>
      </div>
    </div>
  );
}
